import {createApp} from 'vue'
import { createPinia } from 'pinia'
import { createAhIcon } from '@afrihost/icons'
import { createBrandUI } from '@afrihost/brandui'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import * as Sentry from '@sentry/vue'
import './echo.js'
import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}


import App from './App.vue'
import router from './router.js'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
    .use(router)
    .use(pinia)
    .use(createAhIcon)
    .use(createBrandUI)

Sentry.init({
    app,
    dsn: "https://1c21a9218b41c5c72bfa1624e7ad0467@lb.sentry.sys.afrihost.com/37",
    environment: import.meta.env.DEV ? 'local' : 'live',
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", window.location.host],
});

app.mount("#app")
